import React from 'react';

const CheckboxGroup = ({ label, name, options, selectedValues = [], onChange }) => (
    <div className="form-group mb-4">
        {label && <label className="form-label">{label}</label>}
        {options.map((option, index) => {
            const isChecked = selectedValues.includes(option.value);
            return (
                <div key={index} className="col-lg-12">
                    <input
                        type="checkbox"
                        id={`${name}-${option.value}`}
                        name={name}
                        value={option.value}
                        checked={isChecked}
                        onChange={() => onChange(option.value)}
                        className="d-none"
                    />
                    <label
                        className={`padc bullet w-100 d-flex align-items-center gap-3 mb-4 ${isChecked ? 'active-check' : ''}`}
                        htmlFor={`${name}-${option.value}`}
                    >
                        <div className="label-check flex-shrink-0"></div>
                        <span className="metropill">{option.label}</span>
                    </label>
                </div>
            );
        })}
    </div>
);

export default CheckboxGroup;
